import { List,ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import MeasurementSiteIconResource from "../../assets/thermometer.svg"
import { MeasurementSite } from "../../services/RuteplanAPI";

export default function MeasurementSites(props: IRoutePartProps) {

    return (   
        <>
            {props.roadFeatures && props.roadFeatures.measurementSites && props.roadFeatures.measurementSites.length > 0 &&
            <List>
                {props.roadFeatures.measurementSites.map( (measurementSite: MeasurementSite, index: number) => {
                    return (                
                    <ListItem 
                        key={measurementSite.id + index} 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(measurementSite, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(measurementSite)}
                        onMouseOut={props.onMouseLeaveItem}>
                            <img src={MeasurementSiteIconResource} height="24" alt="Measurement site icon"  style={{paddingRight:"5px"}}/>{
                            "Målestasjon: " + measurementSite.id}
                    </ListItem>
                )})}        
            </List> 
            }
        </>             
    );
}